// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Vueaxios from 'vue-axios'

import ElementUI from 'element-ui'
import Echarts from 'echarts'
// import * as echarts from "echarts";
import md5 from 'js-md5';

import vueEsign from 'vue-esign'
Vue.use(vueEsign)

axios.defaults.withCredentials = true
Vue.use(Vueaxios, axios)

Vue.config.productionTip = false
Vue.use(ElementUI);

import './assets/css/reset.css';
import './assets/css/common.css';
import './assets/css/page_common.css';
import './assets/js/flexible.js';
// import './assets/css/index.scss'
import 'element-ui/lib/theme-chalk/index.css';

/* vue-quill-editor */
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import store from "@/store/index.js"

import VueContextMenu from 'vue-contextmenu'
Vue.use(VueContextMenu)

import VeLine from 'v-charts/lib/line.common'
Vue.component(VeLine.name, VeLine)

import VeRing from 'v-charts/lib/ring.common'
Vue.component(VeRing.name, VeRing)

// import Print from 'vue-print-nb'
// Vue.use(Print)
import common from "./assets/js/common"
Vue.prototype.$common = common;
Vue.prototype.$notify = ElementUI.Notification;
Vue.prototype.$message = ElementUI.Message;
// Vue.prototype.$confirm = ElementUI.MessageBox.confirm;
// Vue.prototype.$alert = ElementUI.MessageBox.alert;
Vue.prototype.$echarts = Echarts;
Vue.prototype.$md5 = md5;
Vue.prototype.$store = store;
Vue.prototype.bus = new Vue()

import VueQuillEditor from "vue-quill-editor"
Vue.use(VueQuillEditor)


import Direction from 'vue-direction-key'
Vue.use(Direction)

import Clipboard from 'clipboard'
Vue.prototype.$Clipboard = Clipboard;


import "@/statistics/assets/assets/reset.css"
// import "@/statistics/assets/assets/fonts/font.css"
import "@/statistics/assets/less/common.less"

import Common from '@/statistics/assets/js/common.js';
Vue.prototype.$Common = Common

// Vue.prototype.$positionName = "sh"
Vue.prototype.$positionName = "wz"

/* eslint-disable no-new */

// axios.get('/static/config.json').then((res) => {
//   Vue.prototype.base_url = res.base_url;
// })

new Vue({
  el: '#app',
  router,
  // store,
  components: { App },
  template: '<App/>'
})

let load;
// 设置请求拦截器
axios.interceptors.request.use(config => {
  // console.log(config);
  // console.log(config.url.indexOf("/REC/DATA/SAVE"));
  if (config.url.indexOf("GetToday") < 0 && config.url.indexOf("/REC/DATA/SAVE") < 0) {
    if (!config.headers.Disable && !config.hideLoading) {
      load = ElementUI.Loading.service({
        lock: true,
        background: "rgba(0, 0, 0, 0.2)"
      });
    }
  }
  if (localStorage.getItem('loginToken')) {
    config.headers.Authorization = localStorage.getItem('loginToken')
    config.headers.ACCESSTOKEN = "ed3d56057fc54a1eb5e027b7eb23e397"
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// 设置响应拦截器
axios.interceptors.response.use(res => {
  if (load) load.close()
  return res
}, error => {
  if (load) load.close()
  // 如果是正常接口，会走err，err.response.status值为401 进行跳转及删除token的操作
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // 返回 401 清除token信息并跳转到登录页面
        // localStorage.removeItem('loginToken')
        // if (location.hash != "#/") {
        //   location.reload();
        // }
        // console.log(location)
        // var redirect = window.location.href.split('#')[1]
        // location.reload()
        return Promise.reject("登录已过期,请重新登录");
      case 403:
        return Promise.reject("你没权限查询该资源");
      case 404:
        return Promise.reject("你所访问的资源不存在");
      case 500:
        return Promise.reject("服务器出错啦");
    }
  }
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/main.js